module.exports = __webpack_public_path__ + "img/logo2.5cee6685.png";